import AbstractSegment    from './AbstractSegment';
import UserAttributeModel from 'models/UserAttributeModel';



const model  = new UserAttributeModel();
const DEFINE = model.data;



export default class UserType extends AbstractSegment {
  name = 'user_type';



  get model() { return model }
  get define() { return DEFINE }



  /**
   * constructor
   */
  constructor(context) {
    super(context);
  }



  /**
   * get
   */
  get(defaultValue = null) {
    const id = this._get();
    if (!id) return defaultValue;

    const define = this.getDefineById(id);
    return {
      id      : define.id,
      category: define.category,
      label   : define.label,
    }
  }



  /**
   * get id
   */
  getId(defaultValue = null) {
    const id = this._get();
    return id || defaultValue;
  }



  /**
   * get category
   */
  getCategory(defaultValue = null) {
    const id = this._get();
    if (!id) return defaultValue;
    return this.model.getCategoryById(id);
  }



  /**
   * get label
   */
   getLabel(defaultValue = null) {
    const id = this._get();
    if (!id) return defaultValue;
    return this.model.getLabelById(id);
  }


  /**
   * get define by id
   */
  getDefineById(id) { return this.define.find(row => { return row.id === id }) }



  /**
   * validate
   */
  validate(id) {
    return this.getDefineById(id) ? null : [new Error(`ユーザー種別 ${id} は定義されていません。`)];
  }



  /**
   * set
   */
  set(id) {
    const errors = this.validate(id);
    if (errors) return errors;
    this._set(id);
  }
}



// WEBPACK FOOTER //
// ./src/shared/bc-segments/segments/UserType.js